import { AppUser } from '@eventr/common'
import { Typography } from '@eventr/common-storybook'
import { bs } from '../../state/bound.store'

interface IUserListTextProps {
    users: AppUser[]
}

export const UserListText = ({ users }: IUserListTextProps) => {
    return (
        <Typography
            variant="bodyRegular"
            textOverflow={'ellipsis'}
            width={'70vw'}
            overflow={'hidden'}
            whiteSpace={'nowrap'}
            display={'block'}
        >
            {users
                .map(
                    (user, rowId) =>
                        `${bs().getNameFormatted(user)}${
                            rowId < users.length - 1 ? ', ' : ''
                        }`
                )
                .join('')}
        </Typography>
    )
}
